"use strict";
var $ = require("../internals/export");
var $padStart = require("../internals/string-pad").start;
var WEBKIT_BUG = require("../internals/string-pad-webkit-bug");
$({ target: "String", proto: true, forced: WEBKIT_BUG }, {
  padStart: function padStart(maxLength) {
    return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : void 0);
  }
});
